module.exports = __webpack_public_path__ + "static/IMG_20191205_214533-1ad9faa38ac3174515e67c96243e70df.jpg";